export default __webpack_public_path__ + "static/cover-7-a482565514d96b78619827268df7de76.jpg";